//Utils.js
//Shared utilities for ph5 settings
//components/configuration/ph5/Utils.js
export default function utils () {
	const controls = [{
		name: 'Text',
		value: 'text',
		description: 'Text input (default)'
	}, {
		name: 'Select List',
		value: 'picklist',
		description: 'Choose option from a list'
	}, {
		name: 'Switch',
		value: 'toggle',
		description: 'Toggle Switch'
	}, {
		name: 'Number Input',
		value: 'number',
		description: 'Controlled numerical input'
	}, {
		name: 'Slider',
		value: 'slider',
		description: 'Ranged slider'
	}, {
		name: 'Hidden',
		value: 'native',
		description: 'Use native UI value'
	}];
	
	const data_types = [{
		name: 'Text',
		value: 'string'
	}, {
		name: 'Number',
		value: 'number'
	}, {
		name: 'Yes/No',
		value: 'boolean'
	}];
	
	const native_options = [{
		name: 'None',
		value: '',
	}, {
		name: 'Ambient Light Dimming',
		value: 'autoDim',
	}, {
		name: 'Daylight Savings',
		value: 'timeZone_dst'
	}, {
		name: 'Time Zone',
		value: 'timeZone_abbr'
	}, {
		name: 'Sign name/location',
		value: 'location'
	}, {
		name: 'Serial Number',
		value: 'serialNumber'
	}, {
		name: 'Strobe enabled',
		value: 'strobe_enable'
	}, {
		name: 'GPS Enabled',
		value: 'com3'
	}, {
		name: 'Modem Enabled',
		value: 'modemEnable'
	}, {
		name: 'Radar file size (# samples)',
		value: 'samplesPerFile'
	}, {
		name: 'Bluetooth Enabled',
		value: 'bluetoothEnable'
	}];
	
	const extractChoices = (opts_string) => {
		//val:choice|val:choice
		if(opts_string)
			return Array.from(opts_string.split('|'), 
						  opt => opt.split(':')[1] ? 
						  {name: opt.split(':')[1], value: opt.split(':')[0]} : 
						  {name: opt, value: opt});
		return [];
	}
	const compileChoices = (choices) => {
		return Array.from(choices, choice => choice.value+':'+choice.name).join('|');
	}
	const message = {
		rotateRight : (map) => {
			return Array.from(message.rowCol(map), line => line.reverse().join('')).join(',');
		},
		rowCol : (map) => {
			var out = [];
			map.split(',').forEach((line, l) => {
				line.split('').forEach((pix, p) => {
					if(l === 0)
						out.push([]);
					out[p].push(pix);
				});
			});
			return out;
		},
		rotateLeft : (map) => {
			return Array.from(message.rowCol(map).reverse(), line => line.join('')).join(',');
		},
		extract : (map, width, height, rotate) => {
			var out = Array((rotate ? width : height) * 16).fill('');
			//var prow = 0;
			//var row = 0;
			map.split(':').filter(i => i).forEach((panel, p) => {
				panel.split(',').filter(i => i).forEach((row, r) => {
					//if(p !== 0 && p%width === 0)
					//	prow++;
					out[Math.floor(p / (rotate ? height : width)) * 16 + r]+=row;
				});
			});
			if(rotate)
				return message.rotateRight(out.filter(i => i).join(','));
			return out.filter(i => i).join(',');
		},
		compile : (map, width, height, rotate) => {
			//var out = [];
			var mymap = map;
			if(rotate)
				mymap = message.rotateLeft(map);
			//var panels = Array(width * height).fill(Array(16).fill(''));
			var npans = [];
			//var vpan = 0;
			mymap.split(',').forEach((line, n) => {
				//if(n !== 0 && n%16 === 0)
					//vpan++;
				line.match(/.{1,16}/g).forEach((seg, s) => {
					let x = (Math.floor(n / 16)*(rotate ? height : width))+s;
					//let y = n%16;
					if(npans.length <= x){
						npans.push([seg]);
					} else {
						npans[x].push(seg);
					}
					/*
					console.log('['+x+']['+y+']='+seg);
					if(panels[x][y] !== ''){
						console.log('!overwrite '+x+','+y+' with '+n+','+s);
						console.log(panels[x][y]+' - '+seg);
					}
					panels[x][y]=seg;
					*/
				})
			});
			//console.log(npans);
			//console.log(panels);
			return Array.from(npans, (pan) => pan.join(',')).join(':');
		}
	}
	return {
		controls : controls,
		types: data_types,
		native : native_options,
		extractChoices : extractChoices,
		compileChoices : compileChoices,
		message: message
	}
}
